<template>
    <div class="container">
        <!-- Modal -->
        <div class="modal fade" id="shiftTimeModal" tabindex="-1" role="dialog" aria-labelledby="shiftTimeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <button type="button" class="close" data-dismiss="modal" id="modelbtn" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div class="modal-body">
                        <div class="popup-head line-head mt-2 mb-3">
                            <h2 class="pb-3"> Shift Time </h2>
                        </div>
                        <div class="shift-time-form">
                                 <form @submit.prevent="storeShift">
                            <div class="row">
                                <div class="col-9">
                                    <div class="form-group">
                                        <label class="label block-label"> Shift Name  <em class="required">*</em> </label>
                                        <input type="text" v-model="form.name" placeholder="Please enter shift name" class="form-control"  name="name" />
                                    </div>
                                </div>
                            
                                <div class="col-3">
                                    <div class="form-group">
                                        <label class="label block-label"> Grace Time <em class="required">*</em> </label>
                                        <input type="number" v-model="form.grace_time" class="form-control"  name="grace_time" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                               <div class="col">
                                 <table class="table" >
                                 <thead>
                                 <tr>
                                 <th>*</th>
                                 <th>Day</th>
                                 <th>IN</th>
                                 <th>OUT</th>
                                 </tr>
                                 </thead>
                                 <tbody>
                                 <tr v-for="(obj,index) in form.days" >
                                 <td><input type="checkbox" v-model="form.workingDays" style="-webkit-appearance: checkbox" v-bind:value="obj.day" ></td>
                                 <td>{{obj.day}}</td>
                                 <td>
                                    <vue-timepicker format="hh:mm A" hide-clear-button v-bind:id="'timein'+index" input-class="form-control" placeholder="Time In" v-model="form.days[index].in"></vue-timepicker>
                                  </td>
                                  <td>
                                     <vue-timepicker format="hh:mm A" hide-clear-button v-bind:id="'timeout'+index" input-class="form-control" placeholder="Time Out" v-model="form.days[index].out"></vue-timepicker>
                                 
                                 </td>
                                 </tr>
                                 </tbody>
                                 </table>
                               </div>
                            </div>
                            <div class="row">
                                <div class="col text-right">
                                    <button class="btn btn-primary active"> Done </button>
                                </div>
                            </div>
                                 </form>

                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <!-- shifts popup End-->

          <!-- Edit Modal -->
        <div class="modal fade" id="shiftTimeEditModal" tabindex="-1" role="dialog" aria-labelledby="shiftTimeEditModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <button type="button" class="close" data-dismiss="modal" id="modelbtn" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div class="modal-body">
                        <div class="popup-head line-head mt-2 mb-3">
                            <h2 class="pb-3">Edit Shift</h2>
                        </div>
                        <div class="shift-time-form">
                                 <form @submit.prevent="updateShift">
                            <div class="row">
                                <div class="col-9">
                                    <div class="form-group">
                                        <label class="label block-label"> Shift Name  <em class="required">*</em> </label>
                                        <input type="text" v-model="editform.name" placeholder="Please enter shift name" class="form-control"  name="name" />
                                    </div>
                                </div>
                            
                                <div class="col-3">
                                    <div class="form-group">
                                        <label class="label block-label"> Grace Time <em class="required">*</em> </label>
                                        <input type="number" v-model="editform.grace_time" class="form-control"  name="grace_time" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                               <div class="col">
                                 <table class="table" >
                                 <thead>
                                 <tr>
                                 <th>*</th>
                                 <th>Day</th>
                                 <th>IN</th>
                                 <th>OUT</th>
                                 </tr>
                                 </thead>
                                 <tbody>
                                 <tr v-for="(obj,index) in editform.days" >
                                 <td><input type="checkbox" v-model="editform.workingDays" style="-webkit-appearance: checkbox" v-bind:value="obj.day" ></td>
                                 <td>{{obj.day}}</td>
                                 <td>
                                     <vue-timepicker format="hh:mm A"  hide-clear-button v-bind:id="'timein'+index" input-class="form-control" placeholder="Time IN" v-model="editform.days[index].in"></vue-timepicker>

                                 </td>
                                 <td>
                                     <vue-timepicker format="hh:mm A" hide-clear-button v-bind:id="'timeout'+index" input-class="form-control" placeholder="Time Out" v-model="editform.days[index].out"></vue-timepicker>

                                 </td>
                                 </tr>
                                 </tbody>

                                 </table>
                               </div>
                            </div>
                            <div class="row">
                                <div class="col text-right">
                                    <button class="btn btn-primary active"> Done </button>
                                </div>
                            </div>
                                 </form>

                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <!-- shifts popup End-->
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Shift Management </h1>
                <a href="#" data-toggle="modal" data-target="#shiftTimeModal" class="btn btn-primary float-right active"> + Add New </a>
                <router-link v-bind:to="'/assignShift'"  class="btn btn-primary float-right" style="margin-right:5px">Assign Shift</router-link>
            </div>
            <div class="shift-mangement-top-box mb-3">
                <div class="row">
                    <div class="col-md-4">
                        <div class="shift-management-inner">
                            <span> Default Shift Time </span>
                            <p> {{DefaultShiftTime}} </p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="shift-management-inner pl-md-5">
                            <span> Duration </span>
                            <p> {{DefaultShiftHours}} </p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="shift-management-inner last-box pl-md-5">
                            <span> Total Employees </span>
                            <p> {{DefaultShiftEmp}} </p>
                        </div>
                    </div>
                </div>
            </div>
            <table id="newshifts" class="table table-responsive-xl" style="width:100%">
                <thead>
                <tr>
                    <th>Shift Name</th>
                    <th>Grace Time</th>
                    <th>Department</th>
                    <th>Team</th>
                    <th>Individual</th>
                    <th>Action</th>
                </tr>
                </thead>
            </table>
        </div>

</template>

<script>
     import VueTimepicker from "vue2-timepicker";
    import 'vue2-timepicker/dist/VueTimepicker.css';

    export default {
        components: {
            VueTimepicker
        },
        data() {
            return {
                DefaultShiftTime:'10:00 AM - 06:00 pm',
                DefaultShiftHours:'9 hours',
                DefaultShiftEmp:'9 Employees',
                form: new Form({
                    'name':'',
                    'grace_time':15,
                      'days':[
                         {'in':'10:00 AM','out':'06:00 PM','day':'Monday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Tuesday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Wednesday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Thursday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Friday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Saturday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Sunday'},
                          ],
                    'workingDays':[]
                }),
                 editform: new Form({
                    'name':'',
                    'grace_time':15,
                      'days':[
                         {'in':'10:00 AM','out':'06:00 PM','day':'Monday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Tuesday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Wednesday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Thursday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Friday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Saturday'},
                         {'in':'10:00 AM','out':'06:00 PM','day':'Sunday'},
                          ],
                    'workingDays':[]
                }),
                datatable:'',
                editid:0,
                shiftNames:[]
            };
        },
        mounted() {
            let self=this;
            this.$Progress.start();
            // this.can('shifts|shift_crud').then(result => {
            //     this.shifts = result.shifts;
            //     this.shift_crud = result.crud_shifts;
            // }).then(result => {
            //     if(this.shifts == true){
            //         // this.getShiftsData();
            //     }
            // });
                    this.getShiftsData();
                    this.getdefaultShift();
         
        },
        methods: {
            getdefaultShift(){
              this.$Progress.start();
                 let self=this;
                this.form.get('api/getDefaultShift')
                .then(res => {
                        self.DefaultShiftTime=`${res.data.CompanyAttendanceSetting.start_hrs}:${res.data.CompanyAttendanceSetting.start_mins} ${res.data.CompanyAttendanceSetting.start_ampm} - ${res.data.CompanyAttendanceSetting.end_hrs}:${res.data.CompanyAttendanceSetting.end_mins} ${res.data.CompanyAttendanceSetting.end_ampm}`,
                        self.DefaultShiftHours=res.data.CompanyAttendanceSetting.hrs_required+' hours',
                        self.DefaultShiftEmp=res.data.user+' Employees',

                        self.$Progress.finish();
                    

                })
                .catch(err => {
                    self.$Progress.fail();
                    self.showAlertBox('error','Soemthing went wrong!');
                });
            },
            jsinputmask:function(id){
                $(document).ready(function(){
                            $(`#${id}`).inputmask(
                            "hh:mm:ss", {
                            placeholder: "HH:MM:SS", 
                            insertMode: false, 
                            showMaskOnHover: false,
                            hourFormat: 23
                        }
                        );
                })
            },
           edit(id){

                this.$Progress.start();
                 let self=this;
                        console.log(self.editform.days);

                axios.get('api/getShift/'+id)
                .then(res => {
                    if(res.data.code == 200){
                        self.editid             =res.data.shift.id;
                        self.editform.name      =res.data.shift.name;
                        self.editform.status    =res.data.shift.status;
                        self.editform.grace_time=res.data.shift.grace_time;
                        self.editform.workingDays=res.data.workingDays;
                        // self.editform.name=res.shift.name;
                        // $.each(res.data.days,function(index,data){
                        //     if(jQuery.inArray(data.day, self.editform.workingDays) !== -1){
                        //      self.editform.days[index]=data
                        //     }
                        // })
                        $.each(self.editform.days,function(index,data){
                            if(jQuery.inArray(data.day, self.editform.workingDays) !== -1){
                                $.each(res.data.days,function(resindex,resData){
                                   if(resData.day==data.day)
                                    self.editform.days[index]=resData;
                                })
                            }else{
                    
                                var obj={};
                                obj.in='10:00 AM',
                                obj.out='06:00 PM',
                                obj.day=data.day
                                self.editform.days[index]=obj;
                            }
                        })

                        self.$Progress.finish();
                       $('#shiftTimeEditModal').modal('show');
                    }else{
                        self.$Progress.fail();
                        self.showAlertBox('error','Something went wrong');
                    }

                })
                .catch(err => {
                    self.$Progress.fail();
                    self.showAlertBox('error','Some problem in your form data');
                });
           },
            updateShift:function(){
                  let self=this;
                 var validation=true;
                if(this.editform.name === '' ){
                    this.showAlertBox('error','Shift name field is compulsory');
                    return false;
                } 
               if($.inArray(self.editform.name.toUpperCase(), self.shiftNames)!== -1 ){
               var index=this.shiftNames.findIndex(name=>name===this.editform.name.toUpperCase()) ;
                  

               if(index !== self.editid ){
                    this.showAlertBox('error','Please select a unique shift name');
                    return false;
               }
                } 
                if(this.editform.grace_time<0){
                    this.showAlertBox('error','Grace time should not be negative');
                    return false;
                }
                
                if(this.editform.workingDays.length>0){
                    $.each(this.editform.days,function(index,data){
                        if($.inArray(data.day, self.editform.workingDays) !== -1 && (data.in === '' || data.out ==='')){
                           self.showAlertBox('error','Please provide time in and time out of selected days');    
                           validation=false;
                           return false;
                        }
                    })
                }else{
                    this.showAlertBox('error','Please select at least one working day');
                    return false;
                }
                if(validation){
                    this.$Progress.start();
                    this.editform.put('api/updateShift/'+self.editid)
                    .then(res => {
                        console.log(res.data.status);
                        if(res.data.status){
                            self.$Progress.finish();
                            self.showToastBox('success','Shift updated successfully.');
                            this.editform.name ='';
                        $('#shiftTimeEditModal').modal('hide');
                          var index=this.shiftNames.findIndex(name=>name===this.editform.name.toUpperCase()) ;
                          self.shiftNames[index]=this.editform.name.toUpperCase();
                            self.datatable.ajax.reload();
                        }else{
                            self.$Progress.fail();
                            self.showAlertBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        self.$Progress.fail();
                        self.showAlertBox('error','Something went wrong!');
                    });
                }

            },
            storeShift:function(){
                 let self=this;
                 var validation=true;
                if(this.form.name === '' ){
                    this.showAlertBox('error','Shift name field is compulsory');
                    return false;
                }
                if(this.form.grace_time<0){
                    this.showAlertBox('error','Grace time should not be negative');
                    return false;
                }
                if($.inArray(this.form.name.toUpperCase(), this.shiftNames)!== -1 ){
                    this.showAlertBox('error','Please select a unique shift name');
                    return false;
                }
                if(this.form.workingDays.length>0){
                    $.each(this.form.days,function(index,data){
                        if($.inArray(data.day, self.form.workingDays) !== -1 && (data.in === '' || data.out ==='')){
                           self.showAlertBox('error','Please provide time in and time out of selected days');    
                           validation=false
                           return false;
                        }
                    })
                }else{
                    this.showAlertBox('error','Please select at least one working day');
                    return false;
                }
                if(validation){
                   
                        this.$Progress.start();
                        
                        this.form.post('api/addShift')
                        .then(res => {
                            if(res.data.code == 200){
                                this.form.name ='';
                                self.$Progress.finish();
                                $('#modelbtn').click();
                                self.shiftNames[res.shiftId]=self.form.name.toUpperCase()

                                self.showToastBox('success','Shift created successfully.');
                                self.datatable.ajax.reload();
                            }else{
                                self.$Progress.fail();
                                self.showAlertBox('error','Some problem in your form data');
                            }

                        })
                        .catch(err => {
                            self.$Progress.fail();
                            self.showAlertBox('error','Some problem in your form data');
                        });
                }
            },
             deletedata(id){
                  swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this shift !",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.$Progress.start();
                        let self=this;
                        axios.get('/api/deleteShift/'+id)
                        .then(res => {
                            // alert('ok');
                            self.showAlertBox('success','Shift deleted successfully!');
                            location.reload()
                        }).catch(err => {
                            self.$Progress.fail();
                            self.showAlertBox('error','Something went wrong!');
                        });
                     } else if (result.dismiss === Swal.DismissReason.cancel){
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                })    
            },
             showUserList:function(route,id,reqeustId){
                 if(route=='/shiftDetailUsers/individual'){
                    this.$router.push(route+'/'+reqeustId+'/'+id);
                 }else{
                 this.$router.push(route+'/'+id);
                 }

            },
            getShiftsData: function () {
                var self = this;
                self.datatable = $("#newshifts").DataTable({
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ordering: false,
                    ajax: {
                        url: "api/getNewShifts",
                        method: "get",
                    }, columns: [
                         {render: function(td, cellData, rowData, row, col){ 
                             self.shiftNames[rowData.id]=rowData.name.toUpperCase();
                            return rowData.name;
                        }},
                        {data: "grace_time"},
                        {render: function(td, cellData, rowData, row, col){
                            if(rowData.department>0)
                             return `<a href="#" id="${rowData.id}" requestId="${rowData.request_id}" class="department" style="cursor:pointer;text-align:center">${rowData.department}</a>`;
                            else
                            return rowData.department;
                        }},
                        {render: function(td, cellData, rowData, row, col){
                            if(rowData.team>0)
                             return `<a href="#" id="${rowData.id}" requestId="${rowData.request_id}" class="team" style="cursor:pointer;text-align:center">${rowData.team}</a>`;
                             else
                            return rowData.team;
                        }},
                        {render: function(td, cellData, rowData, row, col){
                            if(rowData.Individual>0)
                             return `<a href="#" id="${rowData.id}" requestId="${rowData.request_id}" class="Individual" style="cursor:pointer;text-align:center">${rowData.Individual}</a>`;
                            else
                            return rowData.Individual;
                        }},
                        {data: "action"},
                    ],
                    "drawCallback": function(settings) {
                         $('.edit').click(function(){ 
                             self.editid=$(this).attr('id');
                             self.edit($(this).attr('id'))
                          })
                        $('.delete').click(function(){ 
                             self.deletedata($(this).attr('id'))
                          })
                           $('#newshifts tbody tr').on('click', 'td:eq(2)', function () {
                               if($(this).children().attr('id') != null)
                                   self.showUserList('/shiftDetail/department',$(this).children().attr('id'),$(this).children().attr('requestId'))

                                } );
                          
                            $('#newshifts tbody tr').on('click', 'td:eq(3)', function () {
                               if($(this).children().attr('id') != null)
                                   self.showUserList('/shiftDetail/team',$(this).children().attr('id'),$(this).children().attr('requestId'))
                               } );
                          
                            $('#newshifts tbody tr').on('click', 'td:eq(4)', function () {
                               if($(this).children().attr('id') != null)
                                   self.showUserList('/shiftDetailUsers/individual',$(this).children().attr('id'),$(this).children().attr('requestId'))
                                } );
                          }
  
                });
            },
        },
        created() {
        }
    }
</script>
